import z from "zod";
/**
 * Whether a prop is a computed prop, decided by its `kind` discriminant. A
 * computed prop carries no `expr` (it lives in the logic layer), so the kind
 * discriminant is the only exhaustive way to tell them apart.
 */
export function isProps2Computed(prop) {
    switch (prop.kind) {
        case "Props2TextComputed":
        case "Props2NumberComputed":
        case "Props2BoolComputed":
        case "Props2NumberArrayComputed":
        case "Props2TextArrayComputed":
            return true;
        case "Props2Text":
        case "Props2Number":
        case "Props2Bool":
        case "Props2NumberArray":
        case "Props2TextArray":
            return false;
    }
}
export const PropsInputSchema = z.discriminatedUnion("kind", [
    z.strictObject({
        kind: z.literal("Props2Bool"),
        key: z.string(),
        value: z.boolean().nullable(),
    }),
    z.strictObject({
        kind: z.literal("Props2Number"),
        key: z.string(),
        value: z.number().nullable(),
    }),
    z.strictObject({
        kind: z.literal("Props2NumberArray"),
        key: z.string(),
        value: z.number().array().nullable(),
    }),
    z.strictObject({
        kind: z.literal("Props2Text"),
        key: z.string(),
        value: z.string().nullable(),
    }),
    z.strictObject({
        kind: z.literal("Props2TextArray"),
        key: z.string(),
        value: z.string().array().nullable(),
    }),
]);
//# sourceMappingURL=props2.js.map